/* eslint-disable quotes */
/* eslint-disable semi */
export const storeGetters = {
  getOrgName: 'getOrgName',
  getLicense: 'getLicense',
  getLicenseByid: 'getLicenseByid',
  getLicenseManagers: 'getLicenseManagers',
  getRoleList: 'getRoleList',
  getUser: 'getUser',
  getTier: 'getTier',
  authenticationResult: 'authenticationResult',
  getLicenseCount: 'getLicenseCount',
  getTiersCount: 'getTiersCount',
  getVsm: 'getVsm',
  getDesignations: 'getDesignations',
  getDomains:'getDomains',
  getDomain: 'getDomain',
  getDepartments:'getDepartments',
  getDepartment: 'getDepartment',
  // snackbar
  getSnackbarText: 'getSnackbarText',
  getCurrentUser:'getCurrentUser',
  getVsmMetricList: 'getVsmMetricList',
  getVsmsList: 'getVsmsList',
  getCustomers:'getCustomers',
  getCustomerProfile:'getCustomerProfile',
  getListOfCustomers:'getListOfCustomers',
  //anlytics
  getDemoUsers: 'getDemoUsers',
  getAgencyUsers: 'getAgencyUsers',
  getUsers: 'getUsers',
  saveHtmlContent:'saveHtmlContent'
  
};
